import ThingsManagerClass from "../../libs/base/ThingsManagerClass";
import ToggleBaseClass from "./ToggleBaseClass";
/**
 * 汎用品を適用・管理
 */
export default class PartsManagerClass extends ThingsManagerClass{
    constructor(_target){
        super();
        this.name = "PartsManagerClass";

        this.target = (_target)? _target : "body";
    }

    onCreate() {

        this.things = {};

        $("[data-toggle_target]",this.target).each((i,e)=>{
            const id = $(e).attr("data-toggle_target");
            if(!this.things["toggle_"+id]) this.things["toggle_"+id] = new ToggleBaseClass(id,this.target);
        });

        super.onCreate();
    }
}